<template>
<div class="chat-meeting" :class="{'is-my': isMy}">
    <div class="chat-meeting__label">
        <span>{{ $t('chat.meeting.connect') }}:</span>
    </div>
    <div class="chat-meeting__link">
        <router-link :to="meetingUrlObject" tag="a" class="chat-meeting__link-url" :title="params.url">
            {{ meetingUrl }}
        </router-link>

        <meeting-copy-button :value="meetingUrl"/>
    </div>
</div>
</template>

<script>
import MeetingCopyButton from "@share/chat/components/chat/atachments/meeting/MeetingCopyButton";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { getBackend } from "@service/router/getters";
import MeetingAttachmentBottom from "@share/chat/components/chat/atachments/meeting/MeetingAttachmentBottom";

export default {
    name: "MeetingsAttachment",
    components: {MeetingAttachmentBottom, MeetingCopyButton },
    props: {
        params: {
            type: Object,
            required: true,
        },
        isMy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        meetingUrlObject() {
            return {
                name: RouteNamesEnum.viewMeetingPublic,
                params: {
                    backend: getBackend(),
                    id: this.params.id
                }
            };
        },
        meetingUrl() {
            const url = this.$router.resolve(this.meetingUrlObject);

            return window.location.origin + url?.href;
        }
    }
}
</script>

<style scoped lang="scss">

.chat-meeting {
    color: #E5E5E5;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: -0.016em;
    max-width: 280px;

    &.is-my {
        //.chat-meeting__label {
        //    font-size: 16px;
        //    line-height: 20px;
        //}

        color: #fff;

        .chat-meeting__link-url {
            color: #fff;
        }
    }


    &__label {
        margin-bottom: 5px;
    }

    &__link {
        display: flex;
        flex-direction: row;
        white-space: nowrap;
        padding-right: 39px;

        &-url {
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 0;
            margin-right: 8px;
            color: #28B764;
        }
    }
}
</style>
